module.exports = __webpack_public_path__ + "static/clients-a37a5571afb34faa4a53a5c0c07ab497.png";